import { Component } from "react";
import { compose } from "redux";

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";

import PropTypes from "prop-types";

import { mandatorsConnector } from "../../../services/users/mandators/Mandators";

class MandatorsComponent extends Component {
  render() {
    let mainInfoStyle = { padding: "8px 4px 4px 16px" };
    let mandators = this.props.currentUser.OrgIdentityData.Mandators;
    let mandatorIds = Object.keys(mandators);

    return (
      <div>
        <h4>Mandators ({mandatorIds.length})</h4>
        <div style={mainInfoStyle}>
          {mandatorIds.map((Id) => {
            return (
              <div
                key={Id}
                style={{ position: "relative", marginBottom: "20px" }}
              >
                <div style={{ position: "absolute", left: "0" }}>
                  <MandatorRemove
                    {...this.props}
                    mandatorId={Id}
                    allow={mandatorIds.length < 1}
                  />
                </div>
                <div style={{ marginLeft: "60px" }}>
                  mandator person id : {Id}
                  <br />
                  mandator ssn : {mandators[Id]}
                </div>
              </div>
            );
          })}
          <MandatorFormComponent {...this.props} />
        </div>
      </div>
    );
  }

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    addMandatorToOrganization: PropTypes.func,
    removeMandatorToOrganization: PropTypes.func,
  };
}

class MandatorRemove extends Component {
  render() {
    return (
      <div>
        <Button
          onClick={this.props.removeMandatorToOrganization.bind(
            this,
            this.props.mandatorId,
            this.props.currentUser.Identity,
          )}
        >
          <CloseIcon />
        </Button>
        <div style={{ color: "red" }}>{this.props.mandatorRemoveError}</div>
      </div>
    );
  }

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    mandatorId: PropTypes.string.isRequired,
    mandatorRemoveError: PropTypes.string,
    removeMandatorToOrganization: PropTypes.func,
  };
}

class MandatorFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { mandatorId: "" };
  }

  render() {
    return (
      <div>
        <div>
          <small>copy ssn of the user you want to add as a mandator</small>
        </div>
        <TextField
          size="small"
          variant="outlined"
          value={this.state.mandatorId}
          onChange={this.updateId}
          label="ssn"
          errorText={this.props.mandatorError}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={this.props.addMandatorToOrganization.bind(
            this,
            this.state.mandatorId,
            this.props.currentUser.Identity,
          )}
          style={{ marginLeft: "5px" }}
        >
          Add ssn
        </Button>
      </div>
    );
  }

  updateId = (event) => {
    this.setState({ mandatorId: event.target.value });
  };

  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    addMandatorToOrganization: PropTypes.func,
    mandatorError: PropTypes.string,
  };
}
export const Mandators = compose(mandatorsConnector)(MandatorsComponent);
